import React from "react";
import { ID } from "common/entities/IEntity";
import * as attachmentFragments from "./article/attachmentFragments";
import * as commonFragments from "./article/commonFragments";
import { FragmentLayout } from "../../core/components/FragmentLayout";

interface IAttachmentListProps {
	article: ID;
	config: any;
}

export default function AttachmentList(props: IAttachmentListProps) {
	return (
		<React.Fragment>
			<FragmentLayout
				layout={props.config.attachmentLayout}
				fragments={{ ...attachmentFragments, ...commonFragments }}
				props={{
					article: props.article,
				}}
			/>
		</React.Fragment>
	);
}



// WEBPACK FOOTER //
// ./src/panels/articleDetails/AttachmentList.tsx